import React from "react";

import styles from "./Section5.module.scss";

export const Section5 = function () {
  return (
    <section id="progOutline" className={`${styles.section5Wrapper} cc--component-container`}>
      <div className={styles.section5Container}>
        <div className={styles.section5Content}>
          <h3>COURSE CURRICULUM</h3>
          <span>Over the duration of this online program, you&rsquo;ll work your way through the following modules:</span>
          <div className={styles.rowContainer}>
            <div className={styles.firstCol}>
              <p>
                <strong>Module 1: AI and Machine Learning — Applications and Foundations</strong>
                <br />
                Become familiar with supervised machine learning and the types of problems it may be applied to.
              </p>
              <p>
                <strong>Module 2: Using AI for Disease Diagnosis and Patient Monitoring</strong>
                <br />
                Examine real-world applications of AI for diagnosis and patient monitoring.
              </p>
              <p>
                <strong>Module 3: Natural Language Processing and Data Analytics in Health Care</strong>
                <br />
                Use AI to extract value-adding outcomes from medical literature and pathology reports.
              </p>
            </div>
            <div className={styles.secondCol}>
              <p>
                <strong>Module 4: Interpretability in Machine Learning — Benefits and Challenges</strong>
                <br />
                Appreciate the importance and benefits of interpretable algorithms.
              </p>
              <p>
                <strong>Module 5: Patient Risk Stratification and Augmenting Clinical Workflows</strong>
                <br />
                Discover how AI can be applied to health care interventions and patient care.
              </p>
              <p>
                <strong>Module 6: Taking An Integrated Approach to Hospital Management and Optimization</strong>
                <br />
                Investigate a holistic approach to optimizing health care processes.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
